import React, { useEffect, useState} from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { Link } from "react-router-dom";
import { BsGeoAltFill, BsCaretDownFill, BsSearch, BsFillMicFill, BsChevronRight, BsArrowRight } from "react-icons/bs";
import mainIcon13 from "../images/mainIcon13.svg";

import Product1 from "../components/Product1";
import Product5 from "../components/Product5";


import point from "../images/point.svg";


import { useAxios } from "../services/useAxios";

import { LanguageIcon, LanguageNm, splitIntoChunk } from "../services/common";

import {Swiper, SwiperSlide} from 'swiper/react';
import SwiperCore, {Autoplay, Navigation, Pagination} from "swiper";
import { useTranslation } from 'react-i18next';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
SwiperCore.use ([ Autoplay , Navigation, Pagination]);


export default function Main (){
 
    
    const { t } = useTranslation();
    const [request] = useAxios();
    const [data, setData] = useState({});
    const lang = localStorage.getItem("language") || "ko";
    

    const fetchData = async () => {
        const response = await request.post("/app/home/getSaleeHomeInfoAPI", {gcVO :{
            nationSeCode : lang
        }});
        if(response.data.resultCode === 200){      
            console.log(response.data.result)
            response.data.result.bestSubItemList = splitIntoChunk(response.data.result.bestItemList,3);  
            setData(response.data.result);        
        }            
    };

    useEffect(() => {
        fetchData();
      }, []);

    return(
        <div className="backGround bgBlue">



            <Header type="main" newItem/>
            <div className="loSchWr">
                <ul className="mainLoWr">
                    <li>    
                        <Link to="/MilegeHistory" className="mlWr">
                            <p className="tit">{t(`Message.home_screen_my_mileage`)}</p>
                            <p className="cont pl24">
                                <img src={point} alt="동전" className="coin"/>
                                {data.myAccmlMlgAmount?data.myAccmlMlgAmount.toLocaleString('ko-KR'):0}
                            </p>
                        </Link>
                    </li>                   
                    <li>
                        <Link to="/DelivManagement" className="mlWr">
                            <p className="tit">{t(`Message.home_screen_dlvy_adres`)}</p>
                            <p className="cont">
                                <BsGeoAltFill className="cOrg"/> 
                                {data.dlvyInfoList  && data.dlvyInfoList.find(e=>e.bassDlvyaraAt === 'Y') ?data.dlvyInfoList.find(e=>e.bassDlvyaraAt === 'Y').dlvyBassAdres:t(`Message.home_screen_basic_dlvy_setting`)}  
                            </p>
                        </Link>
                    </li>
                    <li>
                        <Link to="/Language" className="mlWr">
                            <p className="tit">{t(`Message.language_settings_title`)}</p>
                            <p className="hdLangeWr">
                                <span className="mainHdFlag">
                                    {LanguageIcon()} 
                                </span>
                                {LanguageNm()} 
                            </p>
                        </Link>
                    </li>
                </ul>
                <div className="mainSchWr" onClick={(e) => {window.location.href="/Search"}}>
                    <BsSearch className="schIcon"/>
                    <p>{t(`Message.home_screen_search_hint`)}</p>
                    <button 
                        type="button" 
                        className="micIcon"
                        onClick={(e) => {
                            e.preventDefault(); 
                            e.stopPropagation();
                    }}>
                        <BsFillMicFill/>
                    </button>
                </div>
            </div>

            <div className="mainEventSlideWr">
                <Swiper className="mainEventSlide" 
                    slidesPerView={1.15}
                    spaceBetween={12}
                    autoplay={{delay: 5000}}
                    loop = "true"
                    pagination={{ clickable: true }}
                >
                    {data.bannerList && data.bannerList.filter((el) => el.nationSeCode === lang).map((obj, index) => (
                    <SwiperSlide key={index}>
                        <img src={"https://www.salee.co.kr/com/cmm/getBannerImageView.sale?bannerSn="+obj.bannerSn} alt="이벤트1" />
                    </SwiperSlide>
                    ))}                    
                </Swiper>
            </div>


            <div className="mainCategoryWr">
                <p className="mainTit">Categories</p>
                <div className="cateWr">
                    {data.saleeCategoryList && data.saleeCategoryList.filter( obj => obj.data?.imageFileNm )
                        .sort(function(a, b){ return a.sort - b.sort}).map((obj, index) => (
                        
                    <Link to={"/Categories/"+obj.id} className="cateBtn" key={index}>
                        <img src={"https://www.salee.co.kr/com/cmm/getGoodsClImageView.sale?fileNm="+obj.data.imageFileNm} alt={obj.text}/>
                        <div className="tit">{obj.text}</div>
                    </Link>
                        
                     ))}  

                     {data.saleeCategoryList && data.saleeCategoryList.length !==0 ? (
                     <Link to="/Category" className="cateBtn">
                        <img src={mainIcon13} alt="전체보기"/>
                        <div className="tit">전체보기</div>
                    </Link>                  
                    ):null}
                </div>
            </div>

            <div className="pd20">
                <div className="mainBestSlideWr">
                    <h3 className="mainTit">SALEE BEST ITEM</h3>
                    <div>
                        <Swiper 
                            className="pb30"
                            modules={[Navigation, Pagination]}
                            slidesPerView={1.12}
                            spaceBetween={30}
                            autoplay={false}
                            loop = "true"                            
                            pagination={{ clickable: true }}
                        >
                            {data.bestSubItemList && data.bestSubItemList.map((bestItem, index) => (
                            <SwiperSlide key={index}>
                            {bestItem && bestItem.map((obj, index2) => (
                                <Product5 key={index2}
                                    type="type13"
                                    grad={(index2+1)+(3*index)}
                                    prodName={obj.goodsNm}
                                    img={"https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn="+obj.goodsImageSn}
                                    buy={obj.orderCnt}
                                    disprice={"￦"+(!obj.sleAmount?0:obj.sleAmount).toLocaleString('ko-KR')}
                                    percent={Math.round((!obj.dscntRate?0:obj.dscntRate) * 100)}
                                    cost={"￦"+(!obj.nrmltAmount?0:obj.nrmltAmount).toLocaleString('ko-KR')}
                                    heart
                                    cart
                                    obj = {obj}
                                />
                            ))}         
                            </SwiperSlide>                
                             ))}    
                        </Swiper>
                    </div>
                </div>
            </div>

            
            <div className="mainMeatWr">
                {data.customEventList && data.customEventList.find((e)=>e.eventSn === 25)?(
                <div className="mainMeatDiv">
                    <div className="thumimgAndTit">
                        <div className="imgWr">
                            <img src="https://www.salee.co.kr/resources/asset/shop/img/cow.png" alt="소고기" />
                        </div>
                        <div className="floatTit">
                            <span className="fs14">쫀득 고소한</span>
                            <h3 className="fs16">소고기</h3>
                        </div>
                    </div>
                        {data.customEventList && data.customEventList.find((e)=>e.eventSn === 25).goodsEventTyList.map((obj, index2) => (         
                        <Product5 key={index2}
                            type="type13"
                            grad={(index2+1)}
                            prodName={obj.goodsNm}
                            img={"https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn="+obj.goodsImageSn}
                            buy={obj.orderCnt}
                            disprice={"￦"+(!obj.sleAmount?0:obj.sleAmount).toLocaleString('ko-KR')}
                            percent={Math.round((!obj.dscntRate?0:obj.dscntRate) * 100)}
                            cost={"￦"+(!obj.nrmltAmount?0:obj.nrmltAmount).toLocaleString('ko-KR')}
                            heart
                            cart
                            obj = {obj}
                        />
                        ))}        
                        
                    
                    <Link to="/Categories/26" className="meatMore">더보기 <BsArrowRight /></Link>

                </div>
                ):null}
                {data.customEventList && data.customEventList.find((e)=>e.eventSn === 26)?(
                <div className="mainMeatDiv">
                    <div className="thumimgAndTit">
                        <div className="imgWr">
                            <img src="https://www.salee.co.kr/resources/asset/shop/img/pig.png" alt="돼지고기" />
                        </div>
                        <div className="floatTit">
                            <span className="fs14">쫄깃 탱글한</span>
                            <h3 className="fs16">돼지고기</h3>
                        </div>
                    </div>
                    {data.customEventList && data.customEventList.find((e)=>e.eventSn === 26).goodsEventTyList.map((obj, index2) => (         
                        <Product5 key={index2}
                            type="type13"
                            grad={(index2+1)}
                            prodName={obj.goodsNm}
                            img={"https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn="+obj.goodsImageSn}
                            buy={obj.orderCnt}
                            disprice={"￦"+(!obj.sleAmount?0:obj.sleAmount).toLocaleString('ko-KR')}
                            percent={Math.round((!obj.dscntRate?0:obj.dscntRate) * 100)}
                            cost={"￦"+(!obj.nrmltAmount?0:obj.nrmltAmount).toLocaleString('ko-KR')}
                            heart
                            cart
                            obj = {obj}
                        />
                        ))}      

                        <Link to="/Categories/27" className="meatMore">더보기 <BsArrowRight /></Link>
                </div>
                ):null}

                {data.customEventList && data.customEventList.find((e)=>e.eventSn === 27)?(
                <div className="mainMeatDiv">
                    <div className="thumimgAndTit">
                        <div className="imgWr">
                            <img src="https://www.salee.co.kr/resources/asset/shop/img/chick.png" alt="닭고기" />
                        </div>
                        <div className="floatTit">
                            <span className="fs14">고소 담백한</span>
                            <h3 className="fs16">닭고기</h3>
                        </div>
                    </div>
                    {data.customEventList && data.customEventList.find((e)=>e.eventSn === 27).goodsEventTyList.map((obj, index2) => (         
                        <Product5 key={index2}
                            type="type13"
                            grad={(index2+1)}
                            prodName={obj.goodsNm}
                            img={"https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn="+obj.goodsImageSn}
                            buy={obj.orderCnt}
                            disprice={"￦"+(!obj.sleAmount?0:obj.sleAmount).toLocaleString('ko-KR')}
                            percent={Math.round((!obj.dscntRate?0:obj.dscntRate) * 100)}
                            cost={"￦"+(!obj.nrmltAmount?0:obj.nrmltAmount).toLocaleString('ko-KR')}
                            heart
                            cart
                            obj = {obj}
                        />
                        ))}      
                        <Link to="/Categories/31" className="meatMore">더보기 <BsArrowRight /></Link>
                </div>
                ):null}
            </div>


            {data.mainEventList && data.mainEventList.map((mainEvent, index) => (
            <div className="dfColG12 mainSlideProdWr" key={index}>
                <div className="dfColG4">
                    <div className="dfsb">
                        <div className="dfColG4">
                            <h3 className="mainTit">{mainEvent.emphsPhrase}</h3>
                            <p className="gTit">{mainEvent.eventDc}</p>
                        </div>
                        <Link to={"/EventProduct/"+mainEvent.eventSn} className="moreBtn"><BsChevronRight /></Link>
                    </div>
                </div>
                <div>
                    <Swiper 
                        className="prodSlid1"
                        modules={[Navigation, Pagination]}
                        slidesPerView={2.15}
                        spaceBetween={16}
                        autoplay={false}
                        loop = "true"                        
                        pagination={{ clickable: true }}
                    >
                      {mainEvent.goodsEventTyList && mainEvent.goodsEventTyList.map((obj, index2) => (  
                        <SwiperSlide key={index2}>
                            <Product1 type="type2" 
                            img={"https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn="+obj.goodsImageSn}
                            prodName={obj.goodsNm}
                            disprice={"￦"+(!obj.sleAmount?0:obj.sleAmount).toLocaleString('ko-KR')}
                            percent={Math.round(!obj.dscntRate?0:obj.dscntRate * 100)}
                            cost={"￦"+(!obj.nrmltAmount?0:obj.nrmltAmount).toLocaleString('ko-KR')}
                            heart={true}
                            cart={true}
                            obj = {obj}
                            />
                        </SwiperSlide>
                       ))}
                    </Swiper>
                </div>
            </div>
            ))}  
            


            <div className="dfColG12 mainSlideProdWr">
                <div className="dfColG4">
                    <div className="dfsb">
                        <div className="dfColG4">
                            <h3 className="mainTit">{t(`Message.rcnt_oftn_buy_goods_title`)}</h3>
                            <p className="gTit">{t(`Message.rcnt_oftn_buy_goods_sub_title1`)} <br/> {t(`Message.rcnt_oftn_buy_goods_sub_title2`)} </p>
                        </div>                       
                    </div>
                </div>
                <div>
                    <Swiper 
                        className="prodSlid1"
                        modules={[Navigation, Pagination]}
                        slidesPerView={2.15}
                        spaceBetween={16}
                        autoplay={false}
                        loop = "true"                    
                        pagination={{ clickable: true }}
                    >
                        {data.rcntOftnBuyList && data.rcntOftnBuyList.map((obj, index) => (
                        <SwiperSlide key={index}>
                            <Product1 type="type2" 
                            img={"https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn="+obj.goodsImageSn}
                            prodName={obj.goodsNm}
                            disprice={"￦"+(!obj.sleAmount?0:obj.sleAmount).toLocaleString('ko-KR')}
                            percent={Math.round(!obj.dscntRate?0:obj.dscntRate * 100)}
                            cost={"￦"+(!obj.nrmltAmount?0:obj.nrmltAmount).toLocaleString('ko-KR')}
                            heart={true}
                            cart={true}
                            obj = {obj}
                            />
                        </SwiperSlide>
                        ))} 
                    </Swiper>
                </div>
            </div>


            {/* 
            <div className="dfColG12 recomCateWr">
                <div className="dfColG4">
                    <div className="dfsb">
                        <div className="dfColG4">
                            <h3 className="mainTit">추천 카테고리</h3>
                            <p className="gTit">복잡한 검색 필요없이 상황에 맞는 음식을 추천해드려요.</p>
                        </div>                       
                    </div>
                </div>
                <div className="rcCateList">
                    <Link to="/" className="rcBtn">
                        <div className="imgWr"><img src={"https://www.salee.co.kr/resources/asset/shop/img/recom1.png"} alt="식단관리"/></div>
                        <p className="tit">식단관리</p>
                    </Link>
                    <Link to="/" className="rcBtn">
                        <div className="imgWr"><img src={"https://www.salee.co.kr/resources/asset/shop/img/recom2.png"} alt="반려동물"/></div>
                        <p className="tit">반려동물</p>
                    </Link>
                    <Link to="/" className="rcBtn">
                        <div className="imgWr"><img src={"https://www.salee.co.kr/resources/asset/shop/img/recom3.png"} alt="홈파티"/></div>
                        <p className="tit">홈파티</p>
                    </Link>
                    <Link to="/" className="rcBtn">
                        <div className="imgWr"><img src={"https://www.salee.co.kr/resources/asset/shop/img/recom4.png"} alt="야식추천"/></div>
                        <p className="tit">야식추천</p>
                    </Link>
                    <Link to="/" className="rcBtn">
                        <div className="imgWr"><img src={"https://www.salee.co.kr/resources/asset/shop/img/recom5.png"} alt="간식거리"/></div>
                        <p className="tit">간식거리</p>
                    </Link>
                </div>
            </div>
            */}

            <Footer />
        </div>
    );
};